module.exports = __webpack_public_path__ + "static/compagnie_zoumba-432b196af6be55248330090bc7dc6dcf.png";